// 围观星球 · 吃瓜热评站 静态示例数据
// 说明：数据仅用于静态展示，真实来源请接入后端后替换。

export const site = {
  brand: "围观星球",
  tagline: "神评与评论区名场面收集站",
  desc: "网罗抖音神评论合集和评论区名场面，沙雕热评、吃瓜表情包、搞笑梗图一次放齐。",
  mail: "hello@weiguangxingqiu.example",
};

export const navLinks = [
  { id: "top", label: "首页" },
  { id: "hot", label: "热评榜" },
  { id: "scenes", label: "名场面" },
  { id: "memes", label: "梗图库" },
  { id: "topics", label: "吃瓜话题" },
  { id: "about", label: "关于我们" },
  { id: "contact", label: "投稿联系" },
];

export const tickerComments = [
  "评论区人均段子手，随手一翻全是高手",
  "本来想来看视频，结果在评论区笑到打鸣",
  "一条热评的杀伤力，能顶三条正片",
  "名场面警告：前方神评论高能",
  "吃瓜一时爽，一直吃瓜一直爽",
  "评论区才是我的快乐老家",
];

// 热评榜
export const hotComments = [
  {
    id: 1,
    quote: "主人以为自己在驯服小狗，其实小狗在心里已经给它颁了年度最配合奖。",
    video: "一只小狗学握手成功",
    tag: "治愈系",
    likes: 328000,
    replies: 4210,
    mood: "温柔一刀",
  },
  {
    id: 2,
    quote: "别人的青春是校服和操场，我的青春是空调房里的薯片包装袋。",
    video: "毕业季宿舍整理视频",
    tag: "青春",
    likes: 276500,
    replies: 3890,
    mood: "人间真实",
  },
  {
    id: 3,
    quote: "师傅说这锅粥里不放盐，可我吃出了生活的咸。",
    video: "深夜路边摊熬粥",
    tag: "深夜emo",
    likes: 251200,
    replies: 3675,
    mood: "温柔一刀",
  },
  {
    id: 4,
    quote: "猫：我原谅你了，虽然我不知道你错在哪，但你看起来挺忙的。",
    video: "高冷猫咪翻了个白眼",
    tag: "萌宠",
    likes: 219800,
    replies: 2980,
    mood: "绝杀补刀",
  },
  {
    id: 5,
    quote: "钱虽然不是万能的，但钱能买到让我笑到不行的梗图，就值了。",
    video: "买了限量盲盒的开箱",
    tag: "沙雕",
    likes: 198300,
    replies: 2410,
    mood: "人间真实",
  },
  {
    id: 6,
    quote: "教练说科目二别紧张，把它当成在村里开车，村里可没这么多线。",
    video: "学车被教练支配的一天",
    tag: "考试",
    likes: 187600,
    replies: 2650,
    mood: "反向毒奶",
  },
  {
    id: 7,
    quote: "这不是跳槽，这是给老板换个更好的新同事，我单方面宣布我赢了。",
    video: "办公桌收摊纪念",
    tag: "打工人",
    likes: 172400,
    replies: 2210,
    mood: "绝杀补刀",
  },
];

// 名场面分类
export const sceneCategories = ["全部", "复读现场", "绝杀补刀", "反向毒奶", "走错片场", "跨次元联欢"];

// 评论区名场面
export const scenes = [
  {
    id: 1,
    img: "https://readdy.ai/api/search-image?query=a%20row%20of%20cheerful%20cartoon%20chickens%20each%20holding%20a%20tiny%20speech%20bubble%20all%20saying%20the%20same%20thing%20in%20perfect%20sync%2C%20flat%20vector%20sticker%20illustration%2C%20playful%20meme%20energy%2C%20warm%20cream%20and%20soft%20peach%20background%2C%20coral%20red%20and%20leaf%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=700&height=520&seq=scene-01&orientation=landscape",
    category: "复读现场",
    title: "评论区全员复读机",
    scene: "宠物视频评论区",
    quote: "太可爱了吧 太可爱了吧 太可爱了吧 太可爱了吧",
    highlight: "楼中楼跟着整齐复读上百层，画风逐渐失控",
    likes: "64.2万",
  },
  {
    id: 2,
    img: "https://readdy.ai/api/search-image?query=a%20confident%20cartoon%20hand%20swatting%20away%20a%20tiny%20annoying%20mosquito%20in%20one%20swift%20motion%2C%20flat%20vector%20sticker%20illustration%2C%20playful%20meme%20energy%2C%20warm%20cream%20and%20soft%20peach%20background%2C%20coral%20red%20and%20leaf%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=700&height=520&seq=scene-02&orientation=landscape",
    category: "绝杀补刀",
    title: "一句话终结全场",
    scene: "美食探店评论区",
    quote: "老板：这汤我熬了八小时。 网友：那我上次喝的莫非是锅底的自来水？",
    highlight: "补刀精准，楼主直接笑到手机脱手",
    likes: "88.6万",
  },
  {
    id: 3,
    img: "https://readdy.ai/api/search-image?query=a%20puzzled%20cartoon%20cat%20stepping%20onto%20a%20movie%20film%20set%20with%20a%20clapperboard%20and%20spotlight%2C%20comedic%20wrong-place%20confusion%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20and%20soft%20peach%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=700&height=520&seq=scene-03&orientation=landscape",
    category: "走错片场",
    title: "这楼歪得离谱",
    scene: "科普视频评论区",
    quote: "明明是讲物理的，评论区却开始交流养花心得，我愣是看完了。",
    highlight: "主题直接跑偏到外太空，楼主在线怀疑人生",
    likes: "41.5万",
  },
  {
    id: 4,
    img: "https://readdy.ai/api/search-image?query=a%20cartoon%20man%20in%20an%20office%20chair%20vanishing%20into%20a%20cloud%20of%20poof%20dust%20leaving%20only%20a%20coffee%20cup%20behind%2C%20funny%20left-the-chat%20moment%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20and%20soft%20peach%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=700&height=520&seq=scene-04&orientation=landscape",
    category: "绝杀补刀",
    title: "当场社死撤退",
    scene: "办公室日常评论区",
    quote: "我假装去倒水，其实是想趁机退出这场修罗场。",
    highlight: "一个撤退动作被网友解读出一整部职场剧",
    likes: "52.3万",
  },
  {
    id: 5,
    img: "https://readdy.ai/api/search-image?query=a%20cartoon%20person%20lovingly%20hugging%20a%20flower%20that%20suddenly%20turns%20into%20a%20prickly%20cactus%2C%20backfired%20luck%20comedy%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20and%20soft%20peach%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=700&height=520&seq=scene-05&orientation=landscape",
    category: "反向毒奶",
    title: "毒奶现场打脸",
    scene: "游戏抽卡评论区",
    quote: "我信誓旦旦跟朋友说这发必出，结果保底清零，沉默震耳欲聋。",
    highlight: "预言家当场翻车，评论区排队打卡",
    likes: "77.9万",
  },
  {
    id: 6,
    img: "https://readdy.ai/api/search-image?query=two%20different%20cartoon%20mascot%20animals%20high-fiving%20across%20a%20glowing%20screen%20bridge%20between%20two%20platforms%2C%20cross-platform%20fun%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20and%20soft%20peach%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=700&height=520&seq=scene-06&orientation=landscape",
    category: "跨次元联欢",
    title: "评论区双向奔赴",
    scene: "跨平台梗视频评论区",
    quote: "在抖音刷到你，在另一个平台又刷到你，这是要追我吗？",
    highlight: "同一批网友在两个平台相遇，弹幕式认亲现场",
    likes: "59.8万",
  },
];

// 梗图分类
export const memeCategories = ["全部", "沙雕动物", "打工人", "表情包大户", "上头梗", "躺平文学"];

// 梗图库
export const memes = [
  {
    id: 1,
    img: "https://readdy.ai/api/search-image?query=a%20cartoon%20laughing%20goat%20wearing%20tiny%20party%20glasses%20and%20a%20feather%20boa%2C%20extremely%20overjoyed%20expression%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=640&height=640&seq=meme-01&orientation=squarish",
    category: "沙雕动物",
    title: "快乐源泉羊",
    desc: "笑到画面模糊，适合配一句'今日份快乐到账'",
    hot: true,
  },
  {
    id: 2,
    img: "https://readdy.ai/api/search-image?query=a%20fluffy%20cartoon%20dog%20wrapped%20in%20a%20cozy%20blanket%20with%20a%20wide-eyed%20surprised%20expression%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=640&height=640&seq=meme-02&orientation=squarish",
    category: "沙雕动物",
    title: "震惊小狗",
    desc: "看见工资条时的我本人，瞳孔地震",
    hot: true,
  },
  {
    id: 3,
    img: "https://readdy.ai/api/search-image?query=a%20cartoon%20cat%20typing%20furiously%20on%20a%20tiny%20keyboard%20with%20angry%20steam%20coming%20from%20its%20ears%2C%20online%20debate%20mood%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=640&height=640&seq=meme-03&orientation=squarish",
    category: "表情包大户",
    title: "键盘侠喵",
    desc: "别惹我，我可是会回评论的",
    hot: false,
  },
  {
    id: 4,
    img: "https://readdy.ai/api/search-image?query=a%20cartoon%20person%20facepalming%20hard%20while%20staring%20at%20a%20phone%20screen%20showing%20confusing%20replies%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=640&height=640&seq=meme-04&orientation=squarish",
    category: "打工人",
    title: "血压上来了",
    desc: "看到甲方需求那一刻的经典反应",
    hot: false,
  },
  {
    id: 5,
    img: "https://readdy.ai/api/search-image?query=a%20cartoon%20penguin%20sliding%20down%20an%20ice%20slope%20with%20pure%20joy%20and%20sparkles%20trailing%20behind%2C%20unbothered%20happy%20mood%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=640&height=640&seq=meme-05&orientation=squarish",
    category: "上头梗",
    title: "丝滑企鹅",
    desc: "只要我不尴尬，尴尬的就是别人",
    hot: true,
  },
  {
    id: 6,
    img: "https://readdy.ai/api/search-image?query=a%20grumpy%20cartoon%20cat%20wearing%20a%20tiny%20golden%20crown%20looking%20down%20dismissively%2C%20bossy%20attitude%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=640&height=640&seq=meme-06&orientation=squarish",
    category: "表情包大户",
    title: "本宫不伺候",
    desc: "高冷表情包，回怼杠精专用",
    hot: false,
  },
  {
    id: 7,
    img: "https://readdy.ai/api/search-image?query=a%20happy%20cartoon%20skeleton%20dancing%20at%20a%20tiny%20party%20with%20balloons%20and%20confetti%2C%20carefree%20vibes%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=640&height=640&seq=meme-07&orientation=squarish",
    category: "躺平文学",
    title: "摆烂也要快乐",
    desc: "周一的正确打开方式，先快乐再说",
    hot: false,
  },
  {
    id: 8,
    img: "https://readdy.ai/api/search-image?query=a%20sleepy%20cartoon%20panda%20clutching%20a%20steaming%20coffee%20mug%20with%20droopy%20eyelids%2C%20still%20got%20to%20work%20mood%2C%20flat%20vector%20sticker%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=640&height=640&seq=meme-08&orientation=squarish",
    category: "打工人",
    title: "早八熊猫",
    desc: "咖啡续命，全靠一口仙气吊着",
    hot: true,
  },
];

// 吃瓜话题云
export const topics = [
  { id: 1, name: "沙雕热评大赏", tag: "热评", img: "https://readdy.ai/api/search-image?query=a%20stack%20of%20colorful%20cartoon%20meme%20stickers%20piling%20up%20with%20little%20laughing%20faces%20and%20hearts%2C%20collection%20of%20funny%20comments%20vibe%2C%20flat%20vector%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=520&height=640&seq=topic-01&orientation=portrait" },
  { id: 2, name: "评论区名场面", tag: "名场面", img: "https://readdy.ai/api/search-image?query=a%20giant%20cartoon%20popcorn%20bucket%20with%20star%20eyes%20watching%20drama%20unfold%2C%20spectator%20excitement%2C%20flat%20vector%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=520&height=640&seq=topic-02&orientation=portrait" },
  { id: 3, name: "吃瓜梗图素材", tag: "梗图", img: "https://readdy.ai/api/search-image?query=a%20slice%20of%20watermelon%20mascot%20wearing%20sunglasses%20and%20holding%20a%20phone%2C%20viral%20fun%20vibe%2C%20flat%20vector%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=520&height=640&seq=topic-03&orientation=portrait" },
  { id: 4, name: "神评论合集", tag: "合集", img: "https://readdy.ai/api/search-image?query=a%20cartoon%20crowd%20of%20curious%20heads%20peeking%20over%20a%20giant%20speech%20bubble%2C%20everyone%20loves%20reading%20comments%2C%20flat%20vector%20illustration%2C%20warm%20cream%20background%2C%20coral%20and%20green%20accents%2C%20clean%20minimal%2C%20no%20text&width=520&height=640&seq=topic-04&orientation=portrait" },
];

// 用户口碑
export const testimonials = [
  { id: 1, name: "阿茶不加糖", role: "每晚下饭追更", text: "本来想找个表情包，结果在梗图库笑到停不下来，现在每天都来围观星球转一圈。" },
  { id: 2, name: "不熬夜的咸鱼", role: "评论区十级学者", text: "这里的名场面合集太戳了，感觉就是在还原我刷评论区的真实反应，泪目又好笑。" },
  { id: 3, name: "半糖去冰", role: "素材党本党", text: "做视频剪片子最缺的就是高清梗图，这里整理得明明白白，直接就是我的素材库。" },
  { id: 4, name: "隔壁老王不姓王", role: "快乐传播大使", text: "把热评榜转给朋友，他问我要会员链接，我说不用，围观星球免费又快乐。" },
];

// 常见问题
export const faqs = [
  {
    q: "围观星球的内容可以免费使用吗？",
    a: "可以。站内整理的神评论、名场面和吃瓜梗图素材均供大家免费围观与二次创作。若用于商业用途或需要授权，请先与我们联系确认，尊重每位创作者与原作者的心血。",
  },
  {
    q: "这些神评论和名场面是从哪里来的？",
    a: "内容主要整理自各大短视频平台公开评论区中的高赞热评与出圈名场面，经编辑团队筛选、归纳后以合集形式呈现，并尽量保留原帖语境与出处信息。",
  },
  {
    q: "我自己刷到的神评论能投稿吗？",
    a: "当然可以，我们非常欢迎。你可以在页面底部的投稿表单里填写昵称、联系方式、原视频和评论内容。审核通过后就会出现在对应的合集里，并署上你的昵称。",
  },
  {
    q: "如何快速找到想要的梗图分类？",
    a: "进入梗图库后，上方提供了沙雕动物、打工人、表情包大户、上头梗、躺平文学等分类筛选，也可以在页面顶部搜索框输入关键词直达感兴趣的话题与素材。",
  },
  {
    q: "内容会每天更新吗？",
    a: "会的。编辑团队基本保持每日更新热评榜与名场面合集，热门话题和节假日还会有加更特辑，帮你第一时间接住每一波新梗。",
  },
];